import { apiFetch } from './client';
import type { User } from '@/types/user';

// fetchMe — возвращает текущего юзера или null если 401.
// Используется на boot'е приложения для определения залогинен ли юзер.
export async function fetchMe(): Promise<User | null> {
  try {
    return await apiFetch<User>('/auth/me');
  } catch (err) {
    // 401 — нет сессии, это OK. Любые другие ошибки — бросаем выше.
    if (err && typeof err === 'object' && 'status' in err && (err as { status: number }).status === 401) {
      return null;
    }
    throw err;
  }
}

// logout — DELETE session + clear cookie. После — редиректим юзера на /login.
export async function logout(): Promise<void> {
  await apiFetch('/auth/logout', { method: 'POST' });
}

// loginURL формирует ссылку на старт OIDC-flow с опциональным return_to.
// Используется в LoginScreen на кнопке "Войти через Google".
export function loginURL(returnTo?: string): string {
  if (returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
    return `/auth/google/login?return_to=${encodeURIComponent(returnTo)}`;
  }
  return '/auth/google/login';
}
